// import axios from 'axios';

// import { DANGER } from 'reducers/alert/constants';
// import { errorMessageStringFromResponse } from 'components/alert/error-message-string-from-response';
// import { showAlert } from 'reducers/alert/actions';

// Inspired by https://github.com/acdlite/flux-standard-action and
// https://redux-actions.js.org/docs/api/createAction.html

// Returns an action creator that stores the first argument (probably an object, so you can store multiple key-values
// and destructure) as the action.payload. And the second argument as action.meta; meta can be useful to provide the
// reducer with request parameters that aren't included in a payload returned by the server, for example.
export const makeStandardActionCreator = (ACTION_TYPE) => {
  return (payload/*, meta*/) => ({
    // meta,
    payload,
    type: ACTION_TYPE,
  });
};

// To make action creators that make an API call and dispatch an action creator on success with the response.
// Doesn't handle dispatching for errors.
export const makeApiActionCreator = (apiCall, successActionCreator) => {
  return args => dispatch => {
    return apiCall(args).then(({ data }) => {
      dispatch(successActionCreator(data, args));
    });
  };
};

// To make action creators that make an API call and dispatch an action creator on success with the response.
// And show an error alert on failure. Re-throwing the error so others in the promise chain can respond to.
// IDEA: Avaliar necessidade.
// export const makeApiActionCreatorWithAlertOnError = (apiCall, successActionCreator) => {
//   return args => dispatch => {
//     return apiCall(args)
//       .then(({ data }) => {
//         dispatch(successActionCreator(data, args));
//       })
//       .catch((error) => {
//         dispatch(showAlert({ type: DANGER, message: errorMessageStringFromResponse(error.response) }));
//         throw error;
//       });
//   };
// };

// Our API has paging built-in by default, returning a `next` URL in the results
// as long as there are more results to get. So this helper makes it easy to write
// action creators that make repeated API requests until all resources at the
// endpoint have been fetched, dispatching an action for each page of data as it
// comes in (so that the UI can update incrementally).
//
// Example usage:
//   // successActionCreator
//   export const SUBJECTS_FETCHED = 'SUBJECTS::SUBJECTS_FETCHED';
//
//   export const subjectsFetched = (payload, meta) => {
//     return {
//       meta,
//       payload,
//       type: SUBJECTS_FETCHED,
//     };
//   };
//
//   // apiCall
//   const fetchSubjects = queryParams => (
//     axios.get(<URL with queryParams>)
//   );
//
//   // async action creator
//   export const fetchSubjects = makePaginatedApiActionCreator(
//     api.fetchSubjects,
//     subjectsFetched,
//   );

// IDEA: Avaliar necessidade.
// export const makePaginatedApiActionCreator = (apiCall, successActionCreator, requestActionCreator) => {
//   return args => (dispatch) => {
//     const dispatchResultsAndFetchNextIfPresent = ({ data }) => {
//       dispatch(successActionCreator(data.results, args));
//       if (data.next !== null) {
//         return axios.get(data.next).then(dispatchResultsAndFetchNextIfPresent);
//       } else {
//         Promise.resolve({ data });
//       }
//     };
//
//     if (requestActionCreator) {
//       dispatch(requestActionCreator(undefined, args));
//     }
//     return apiCall(args).then(dispatchResultsAndFetchNextIfPresent);
//   };
// };



// WEBPACK FOOTER //
// ./src/reducers/action-helpers.js